import { useParams } from "react-router-dom";
import React from "react";
// import Ep0001TruthLiberty from "../assets/transcripts/Ep0001TruthLiberty";
import Seo from "../Seo";
import GoToTop from "../GoToTop";
import TranscriptsList from "../assets/TranscriptsList";
import { Link } from "react-router-dom";
// import TLNyoutubeBtnEmbed from "../assets/images/TLNyoutubeBtnEmbed";
// import TLNfbBtnEmbed from "../assets/images/TLNfbBtnEmbed";
// import MSfbBtnEmbed from "../assets/images/MikeShelbyFBEmbed";
// import Considerations from "./Considerations";
import AsideContent2 from "../AsideContent2";

// <Seo title="React SEO | About Page" description="description for about page" />
// function Content() {
const TranscriptPage = () => {
    const trparams = useParams();
    const trArticleId = trparams.trArticleId;
    const trquoteId = trparams.trquoteId;
    const transcript = TranscriptsList.list.find(transcript => transcript.firstName === trArticleId);
    const trquote = transcript.quotes.find(trquote => trquote.id === trquoteId);
  
    // console.log(transcript.quotes[0].id)
    // console.log(trquote.id);
    // console.log(trquote.date);
   // console.log(trquoteId);

  function MainContentTX() {
    
  
    return (
      <>
      <Seo title={trquote.tabHeading} description={trquote.metaDescription} keywords={trquote.keywords} />
      <h2 className="sectionHeader"><span className="by">{transcript.by}</span> {transcript.lastName} </h2>
      <blockquote className="main">
        <div className="rListCont">
      <p><b><i>{trquote.from}</i></b><cite className="citeTitle">{trquote.title}</cite></p>
      {trquote.content.map((paragraph, i) => {
        if (paragraph.red) { 
            // let norm = paragraph.red.normal;
            // let redBold = paragraph.red.bold;
            // let redNorm = paragraph.red.normal;
          return (
            <p key={i}>
                {paragraph.red.normal}
                <span className="redLetters">{paragraph.red.redNorm}</span>
                <span className="redLetters"><b>{paragraph.red.redBold}</b></span>
                <span className="redLetters">{paragraph.red.redNorm2}</span>
                <b>{paragraph.red.bold2}</b>
                {paragraph.red.normal2}
                <span className="redLetters"><b>{paragraph.red.redBold2}</b></span>
                <span className="redLetters">{paragraph.red.redNorm3}</span>
                {paragraph.red.normal3}
            </p>
          )} else {
        return (
          <p key={i}><b>{paragraph.bold}</b>{paragraph.normal}<b>{paragraph.bold2}</b>{paragraph.normal2}</p>
      )}    
       })}
      
      </div>  
      </blockquote>
      </>
  );
  };
  // <ConsiderationsTX />
  // function ConsiderationsTX(){
  //   return (
  //     <>
  //     <h2 className="sectionHeader">Considerations</h2>
  //         <div className="main">
  //           {trquote.considerations.map((quoteBlock, id) => {
  //             return (
  //                 <React.Fragment key={id}>
  //                 {quoteBlock.content.map((paragraph, i) => {
  //                     return (
  //                         <p key={i}>{paragraph}</p>
  //                     )
  //                 })}
  //                 <p><b>{quoteBlock.title}</b> {quoteBlock.date}</p>
  //                 <hr />
  //                 </React.Fragment>
  //           )})}          
  //         </div>
  //     </>
  //   );
  // };  
  // function AsideContentTX() {
  

  //     const EmbedImage = transcript.image;
  //     const BtnImage = TLNyoutubeBtnEmbed;
  //     const FBBtnImage = TLNfbBtnEmbed;
  //     const MSBtnImage = MSfbBtnEmbed 
  //     return (
  //         <>
  //         <div className="embedImage">    
  //         <EmbedImage />
  //         </div>
  //         <h2 className="sectionHeader">Follow Us</h2>
  //   	    <div className="main asideMain">
  //           <p><b>YouTube - TrueLibertyNorth</b> - Official Channel</p>
  //           <a href="https://www.youtube.com/@TrueLibertyNorth" title="TrueLibertyNorth YouTube"  
  //                     target="_blank" rel="noreferrer" className="rLinks">
  //               <div className="btnImage">    
  //                   <BtnImage />
  //               </div>
  //           </a>
  //           <hr className="asideDiv" />
  //           <p><b>YouTube - TrueLibertyNorth</b> - Subscribe</p>
  //           <div className="g-ytsubscribe asideDiv" data-channelid="UCbiafnj1CoWFT5R4QNLu20Q" data-layout="default" data-count="default"></div>
  //           <hr className="asideDiv" />
  //           <p><b>Facebook - True Liberty North</b></p>
  //           <a href="https://www.facebook.com/TrueLibertyNorth" title="True Liberty North Facebook"  
  //                     target="_blank" rel="noreferrer" className="rLinks">
  //               <div className="btnImage">    
  //                   <FBBtnImage />
  //               </div>
  //           </a>
  //           <hr className="asideDiv" />
  //           <p><b>Facebook - Mike Shelby</b></p>
  //           <a href="https://www.facebook.com/profile.php?id=100013913299532" title="Mike Shelby Facebook"  
  //                     target="_blank" rel="noreferrer" className="rLinks">
  //               <div className="btnImage">    
  //                   <MSBtnImage />
  //               </div>
  //           </a>
  //         </div>
          
  //         </>
  //     );
  //   };
  return (
        <div className="content">
            <main>
                <MainContentTX />
                <h2 className="back"><Link to="/Transcripts" title="Back to Transcripts" className="backLink link">- BACK -</Link></h2>
            </main>
            <aside>
                <AsideContent2 resource={transcript} />
            </aside>
            <GoToTop />
  	    </div>
    );
}

export default TranscriptPage;
